import { ASSET_REGISTER_SORTS, ASSET_STATUSES, SERVICE_SITE_SORTS } from '@sahab/contracts'
import { z } from 'zod'
import { SERVICE_PAGE_SIZES } from '../search'

/** The site page: the place open in the tree (none: the site itself) and whether archived places show. */
export const serviceSitePageSearchSchema = z.object({
  place: z.uuid().optional().catch(undefined),
  archived: z.boolean().optional().catch(undefined),
})
export type ServiceSitePageSearch = z.infer<typeof serviceSitePageSearchSchema>

/**
 * The sites register (`/service/sites`) lives in the URL: the view (sites, or every site's assets), the
 * search text (both views), sort and page; the Assets view's status, type and sort; the New site sheet.
 */
export const serviceSitesSearchSchema = z.object({
  view: z.enum(['assets']).optional().catch(undefined),
  q: z.coerce.string().trim().max(200).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z
    .number()
    .refine((n): n is (typeof SERVICE_PAGE_SIZES)[number] =>
      (SERVICE_PAGE_SIZES as readonly number[]).includes(n),
    )
    .optional()
    .catch(undefined),
  sort: z.enum(SERVICE_SITE_SORTS).optional().catch(undefined),
  assetStatus: z.enum(ASSET_STATUSES).optional().catch(undefined),
  assetType: z.uuid().optional().catch(undefined),
  assetSort: z.enum(ASSET_REGISTER_SORTS).optional().catch(undefined),
  /** Opens the New site sheet. */
  new: z.boolean().optional().catch(undefined),
})
export type ServiceSitesSearch = z.infer<typeof serviceSitesSearchSchema>
